import { ShippingMethod } from '~/lib/data-contract/salesforce';
import { useTranslation } from '~/shared/utils/translation';

export const useCheckoutUtils = () => {
    const { translate } = useTranslation();

    const getDays = (carriers?: ShippingMethod[] | ShippingMethod) => {
        if (!carriers) {
            return null;
        }

        const [carrier] = Array.isArray(carriers) ? carriers : [carriers];
        return carrier?.c_estimatedArrivalTime ?? null;
    };

    const getMinPrice = (carriers?: ShippingMethod[]) => {
        if (carriers?.length) {
            const minPrice = Math.min(...carriers.map((c) => c.c_adjustedPrice as number));
            const formattedPrice = minPrice.toFixed(2).replace('.', ',');
            return formattedPrice;
        } else {
            return null;
        }
    };

    const getCtaLabel = (currentShipmentStep: number, numberOfShipments: number) => {
        const isLastShipment = currentShipmentStep === numberOfShipments;

        if (isLastShipment) {
            return translate('checkout.ctaLabel.step2');
        }

        return translate('checkout.ctaLabel.splitDelivery', {
            next: String(currentShipmentStep + 1),
            total: String(numberOfShipments),
        });
    };

    return {
        getDays,
        getMinPrice,
        getCtaLabel,
    };
};
